export default "__VITE_ASSET__CohRjMm1__"